import getIn from '@alexaivars/get-in';
import createResourceDataReducer from 'lib/createResourceDataReducer';
import createResourceListReducer from 'lib/createResourceListReducer';
import createResourceStatusReducer from 'lib/createResourceStatusReducer';
import { READ_STORY_STREAM, LOAD_MORE_NEWS } from './actions';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { NAME } from './constants';
import { STATES } from 'lib/constants';

const newsLoadMoreLink = (state = null, action = {}) => {
  switch (action.type) {
    case `${READ_STORY_STREAM}_${STATES.SUCCESS}`:
    case `${LOAD_MORE_NEWS}_${STATES.SUCCESS}`:
      return getIn(action, ['payload', 'body', 'links', 'next'], null);
    default:
      return state;
  }
};

const news = combineReducers({
  status: createResourceStatusReducer([READ_STORY_STREAM, LOAD_MORE_NEWS]),
  data: createResourceDataReducer(READ_STORY_STREAM, LOAD_MORE_NEWS),
  list: createResourceListReducer(READ_STORY_STREAM, LOAD_MORE_NEWS),
  loadMoreLink: newsLoadMoreLink,
});

export const getNewsData = state => getIn(state, [NAME, 'news', 'data'], {});
export const getNewsIds = state => getIn(state, [NAME, 'news', 'list'], []);
export const getNewsStatus = state =>
  getIn(state, [NAME, 'news', 'status'], STATES.PENDING);
export const getNewsLoadMoreLink = state =>
  getIn(state, [NAME, 'news', 'loadMoreLink'], null);

export const getStoryStream = createSelector(
  [getNewsIds, getNewsData, getNewsStatus],
  (ids, data, status) => {
    // TODO: handle json api respon in fetch or saga.
    return ids.map(id => ({ id, ...data[id].attributes }));
  },
);

export const getStoryStreamStatus = getNewsStatus;

export default combineReducers({
  news,
});
